import React from "react";
import PropTypes from "prop-types";
import Carousel from "@/bit/components/next13.components.carousel";
import StreamingSlide from "../streaming-slide";
import style from "./style";

const StreamingCarouse = ({ slides, taggingInfo }) => {
  return (
    <>
      <div className="streaming-carousel">
        <Carousel
          slideSeparation={8}
          arrowWidth={50}
          pointsWidth={10}
          blurColor={[11, 39, 57]}
          className="StreamingPlatform"
        >
          {slides &&
            Array.isArray(slides) &&
            slides.map((e, i) => (
              <StreamingSlide
                imgDesktop={e["Image-1"]}
                imgMobile={e["Image-2"]}
                title={e["Text-1"]}
                seriesText={e["Text-2"]}
                suscriptionText={e["Text-3"]}
                aditionalPriceText={e["Text-4"]}
                price={e["Price"]}
                button={e["Button-1"]}
                cardLink={e["CustomLink-1"]}
                key={`slide-${i}-${e["Text-1"]["text"]}`}
                taggingInfo={taggingInfo}
              />
            ))}
        </Carousel>
      </div>
      <style jsx>{style}</style>
    </>
  );
};

export default StreamingCarouse;

StreamingCarouse.propTypes = {};
StreamingCarouse.defaultProps = {};
